/**
 * API接口监控接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiStatisticService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region API接口监控
  /**
   * 接口监控列表
   * @param param
   * @returns {Observable<any>}
   */
  ApiCheck(uri) {
    let uriList=this.prefix.split('/');
    let baseUri=uriList[0]+"//"+uriList[2]+"/";
    const url = baseUri+uri + '/monitor/check';
    return this.http.Get(url);
  }

    /**
   * 服务监控列表
   * @param param
   * @returns {Observable<any>}
   */
  ApiStatus(param) {
    const url = this.prefix + 'monitor/status';
    return this.http.Get(url, param);
  }

  /**
   * 管理服务(1：启动-默认 2：暂停)
   * @param param
   * @returns {Observable<any>}
   */
  ApiManage(param) {
    const url = this.prefix + 'monitor/manage'+param;
    return this.http.Get(url);
  }
  //#endregion

}
